import FavoritesContainer from './FavoritesContainer';

export default FavoritesContainer;
